'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _matchesSelector = require('./matchesSelector');

var _matchesSelector2 = _interopRequireDefault(_matchesSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function selectParent(selector, node) {
  node = node.parentElement;
  while (node) {
    if ((0, _matchesSelector2.default)(node, selector)) {
      return node;
    }
    node = node.parentElement;
  }

  return false;
} /**
   * Copyright (c) 2015-present, Zippy Technologies
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

exports.default = selectParent;